import { IFilter } from '@epicuro-next/ataraxia/models';
import { FilterQueryParams } from '@epicuro-next/models/products';
import { createAction, props } from '@ngrx/store';
import {
  Filter,
  Product,
  SearchQuery,
  Sorting,
  SortingDirection,
} from 'graphql-api/gql-api-interfaces';

/**
 * Makes a GQL request to fetch products
 */
export const loadProducts = createAction(
  '[ProductBasket] Load Products',
  props<{
    clear: boolean;
  }>(),
);

/**
 * Appends the products to the products array in the state
 */
export const loadProductsSuccess = createAction(
  '[ProductBasket] Load Products Success',
  props<{ products: Product[]; resultCount: number }>(),
);

/**
 * Needs only for ECCO and should be retired eventually
 * Updates products with discounts
 */
export const updateProductsWithDiscounts = createAction(
  '[ProductBasket] Update Product with discounts',
  props<{ products: Product[] }>(),
);

/**
 * Returns the previous state
 */
export const loadProductsFailure = createAction(
  '[ProductBasket] Load Products Failure',
  props<{ error: string }>(),
);

/**
 * Sets the sorting options
 */
export const setSortingParams = createAction(
  '[ProductBasket] Set the sorting parameters',
  props<{ sortField: string; sortDirection: SortingDirection }>(),
);

export const initSortingParams = createAction(
  '[ProductBasket] Set initial sorting parameters',
  props<{ sortField: string; sortDirection: SortingDirection }>(),
);

/**
 * Makes a GQL request to fetch filters
 */
export const loadFilters = createAction('[ProductBasket] Load Filters');

export const loadDefaultFilters = createAction(
  '[ProductBasket] Load default filters',
);

export const loadDefaultFiltersSuccess = createAction(
  '[ProductBasket] Load default filters success',
  props<{ sorting: Sorting[]; filters: Filter[] }>(),
);

/**
 * Updates the state on response success of the filters query in GQL
 */
export const loadFiltersSuccess = createAction(
  '[ProductBasket] Load Filters Success',
  props<{
    sorting: Sorting[];
    filters: Filter[];
    previousSearchQuery: SearchQuery | null;
    currentSearchQuery: SearchQuery;
  }>(),
);

export const loadStrippedFiltersSuccess = createAction(
  '[ProductBasket] Load stripped filters success',
);

/**
 * Updates the state on response success of the filters query in GQL
 */
export const loadFiltersFailure = createAction(
  '[ProductBasket] Load Filters Failure',
  props<{ error: string }>(),
);

/**
 * Toggle a single filter.
 */
export const toggleFilter = createAction(
  '[ProductBasket] Toggle Filter',
  props<
    IFilter & {
      resetOtherFilters?: boolean;
      replaceUrl?: boolean;
    }
  >(),
);

export const openFiltersModal = createAction(
  '[ProductBasket] Open Filters Modal',
);

/**
 * Clear active filters.
 */
export const clearFilters = createAction(
  '[ProductBasket] Clear Filters',
  props<{ skipParams: boolean; keepPreset?: boolean }>(),
);

/**
 * Remove active filters except the search query
 */
export const removeFilters = createAction('[ProductBasket] Remove Filters');

/**
 * Clear active filters without updating url params. Dispatched from other pages
 */
export const resetFilters = createAction('[ProductBasket] Reset Filters');

/**
 * Set search query
 */
export const setSearchQuery = createAction(
  '[ProductBasket] Set search query',
  props<{ query: string }>(),
);

export const setSearchQuerySilent = createAction(
  '[ProductBasket] Set search query silent',
  props<{ query: string }>(),
);

/**
 * Remove multiple filters di field ID
 */
export const removeFiltersById = createAction(
  '[ProductBasket] Remove filters by ID',
  props<{ fieldId: string }>(),
);

/**
 * Set params from URL
 */
export const setParamsFromURL = createAction(
  '[ProductBasket] Set params from URL',
  props<{
    filters: FilterQueryParams;
    preset?: string;
    collapse?: boolean;
    orderedProductsBrandId?: string;
  }>(),
);

/**
 * Set the default value of the preset filter
 */
export const setRuleEnginePresetValue = createAction(
  '[ProductBasket] Set the rule engine preset value value',
  props<{ defaultPreset: string; resetToDefaultPreset: boolean }>(),
);

export const setRuleEngineCollapseValue = createAction(
  '[ProductBasket] Set the rule engine collapse value value',
  props<{ defaultCollapse: boolean }>(),
);

export const exportProductsSearchResult = createAction(
  '[ProductBasket] Export Products Search Result',
);

export const exportProductsSearchResultSuccess = createAction(
  '[ProductBasket] Export Products Search Result Success',
);

export const exportProductsSearchResultFailed = createAction(
  '[ProductBasket] Export Products Search Result Failed',
  props<{ error: string }>(),
);

export const setCollapseParam = createAction(
  '[ProductBasket] Set collapse param',
  props<{ collapse: boolean }>(),
);

export const setSubsites = createAction(
  '[ProductBasket] Set subsites',
  props<{ subsites: string | null }>(),
);

export const setCatalogOnlyMode = createAction(
  '[ProductBasket] Set catalog only mode',
  props<{ value: boolean }>(),
);

export const setHorizontalView = createAction(
  '[ProductBasket] Set horizontal view mode',
  props<{ value: boolean }>(),
);

export const setFiltersVisible = createAction(
  '[ProductBasket] Set filters visibility',
  props<{ value: boolean }>(),
);
